import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/cmmData/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/cmmData/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/cmmData/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/cmmData/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/cmmData/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/cmmData/delete/batch', {
    params: {
      ids
    }
  })
}
